// extracted by mini-css-extract-plugin
export var formContainer = "_mo-0";
export var message = "_mo-1";